import React, { Component } from 'react';
import Animation from 'app/shared/modules/Animation';
import animationData from 'app/shared/modules/frontpage/HomeHeroAnimation.json';
import BackgroundSrc from 'images/homeHeroLargeBackground.svg';
import Button from 'app/shared/core/Button';
import {
  homeHubAnimatedFooterAnimationCSS,
  homeHubAnimatedFooterBackgroundCSS,
  homeHubAnimatedFooterContentsCSS,
  homeHubAnimatedFooterCSS,
  homeHubAnimatedFooterPausePlayButtonCSS,
} from 'app/shared/modules/HomeHub/styles';

type AnimatedFooterState = {
  isPlaying: boolean;
};

export default class AnimatedFooter extends Component<Record<string, never>, AnimatedFooterState> {
  state: AnimatedFooterState = {
    isPlaying: true,
  };

  handlePausePlay = () => {
    const { isPlaying } = this.state;
    this.setState({ isPlaying: !isPlaying });
  };

  render() {
    const { isPlaying } = this.state;
    return (
      <div className={homeHubAnimatedFooterCSS} aria-hidden="true">
        <div className={homeHubAnimatedFooterContentsCSS}>
          <Animation
            className={homeHubAnimatedFooterAnimationCSS}
            animationData={animationData}
            shouldLoop
            shouldAutoplay
            isPlaying={isPlaying}
          />
          <img src={BackgroundSrc} className={homeHubAnimatedFooterBackgroundCSS} alt="" />
        </div>
        <div className={homeHubAnimatedFooterPausePlayButtonCSS}>
          <Button onClick={this.handlePausePlay} btnType="default" size="sm">
            {isPlaying ? 'Pause' : 'Play'}
          </Button>
        </div>
      </div>
    );
  }
}
